// import aauMin from 'assets/icons/aau.min.webp';
// import aau from 'assets/icons/aau.webp';
// import akanthasMin from 'assets/icons/akanthas.min.webp';
// import akanthas from 'assets/icons/akanthas.webp';
// import butterflyMin from 'assets/icons/butterfly.min.webp';
// import butterfly from 'assets/icons/butterfly.webp';
import refinebathroomsMin from 'assets/icons/refinebathrooms.min.webp';
import refinebathrooms from 'assets/icons/refinebathrooms.webp';
import cleverlocalMin from 'assets/icons/cleverlocal.min.webp';
import cleverlocal from 'assets/icons/cleverlocal.webp';
import rasoMin from 'assets/icons/raso.min.webp';
import raso from 'assets/icons/raso.webp';
import converselabsMin from 'assets/icons/converselabs.min.webp';
import converselabs from 'assets/icons/converselabs.webp';
import a4dMin from 'assets/icons/a4d.min.webp';
import a4d from 'assets/icons/a4d.webp';
import triaddiagnosticsolutionsMin from 'assets/icons/triaddiagnosticsolutions.min.webp';
import triaddiagnosticsolutions from 'assets/icons/triaddiagnosticsolutions.webp';
// import lanexcorpMin from 'assets/icons/lanexcorp.min.webp';
// import lanexcorp from 'assets/icons/lanexcorp.webp';
import ueMin from 'assets/icons/ue.min.webp';
import ue from 'assets/icons/ue.webp';
// import ccoiMin from 'assets/icons/ccoi.min.webp';
// import ccoi from 'assets/icons/ccoi.webp';
// import iecesMin from 'assets/icons/ieces.min.webp';
// import ieces from 'assets/icons/ieces.webp';
// import hireplicityincMin from 'assets/icons/hireplicityinc.min.webp';
// import hireplicityinc from 'assets/icons/hireplicityinc.webp';

const details = {
  name: {
    first: 'Marjay',
    last: 'Imperial',
    nickname: 'Roy',
  },
  education: [
    {
      school: 'College of Computer Studies and Systems',
      url: '',
      icon: ue,
      iconMin: ueMin,
      location: 'Zamboanga City Campus, Philippines',
      degree: 'Bachelor',
      major: 'Science In Information Technology',
      start: 'Jun 2011',
      end: 'Apr 2015',
    },
  ],
  experience: [
    {
      company: 'A4D Inc',
      url: '',
      icon: a4d,
      iconMin: a4dMin,
      location: 'Carlsbad, CA, United States',
      contract: 'Full-time',
      position: 'AI Software Developer',
      start: 'Oct 2024',
      end: 'May 2025',
      description: [
        'Architected AI-native agile planning platform with Next.js, Node.js, and PostgreSQL, reducing manual work from 16h to 2h.',
        'Engineered Claude AI-powered user story generation system from scattered feature requests.',
        'Implemented real-time collaboration with capacity estimation and risk assessment, accelerating delivery by 75%.',
        'Developed integrations with Jira, GitHub, Slack, Asana, and Trello for seamless data import.',
        'Designed MCP servers and clients for secure AI model communication and dynamic context sharing.',
      ],
      skills: [
        'Next.js',
        'Node.js',
        'PostgreSQL',
        'AI/ML Integration',
        'Claude AI',
        'Real-time Collaboration Systems',
        'Agile Workflow Automation',
        'Jira Integration',
        'Model Context Protocol',
      ],
    },
    {
      company: 'Converse Laboratories Inc',
      url: '',
      icon: converselabs,
      iconMin: converselabsMin,
      location: 'New York, United States',
      contract: 'Full-time',
      position: 'AI Software Developer',
      start: 'Dec 2023',
      end: 'Oct 2024',
      description: [
        'Architected AI voice calling system with Node.js, FastAPI, Twilio, and OpenAI.',
        'Integrated multi-provider STT (Deepgram, Google, Azure) and TTS (PlayHT, Coqui, Elevenlabs) pipelines.',
        'Implemented GPT-powered real-time conversation manager with sentiment-aware voice personas.',
        'Designed WebSocket + Redis audio streaming for 1000+ concurrent calls under 100ms latency.',
        'Built telephony server for call routing, inbound/outbound management, and voice synthesis via Twilio API.',
      ],
      skills: [
        'Python',
        'FastAPI',
        'LangChain',
        'Deepgram',
        'Elevenlabs',
        'Redis',
        'WebSocket',
        'RAG application',
        'Voice agent',
      ],
    },
    {
      company: 'Freelance',
      url: '',
      icon: '',
      iconMin: '',
      location: 'Remote',
      contract: 'Full-time',
      position: 'AI Software Developer',
      start: 'Apr 2023',
      end: 'May 2024',
      description: [
        'Built cross-platform AI social app with React Native, Node.js, and PostgreSQL.',
        'Engineered AI character system with traits, backstories, memory, and evolving personalities.',
        'Developed Instagram-like social feed with posts, comments, likes, DMs, and AI-generated content.',
        'Integrated AI image generation and collaborative artwork features for dynamic content creation.',
        'Implemented scalable backend with PostgreSQL optimizations for real-time AI persona interactions.',
      ],
      skills: [
        'React Native',
        'Node.js',
        'PostgreSQL',
        'Redis',
        'WebSockets',
        'AI/ML Integration',
        'Generative AI (Image & Text)',
        'Character & Persona Modeling',
        'Real-time Messaging',
        'AWS',
        'Terraform',
      ],
    },
    {
      company: 'Refine Bathrooms',
      url: '',
      icon: refinebathrooms,
      iconMin: refinebathroomsMin,
      location: 'Manchester, United Kingdom',
      contract: 'Full-time',
      position: 'AI Automation Engineer',
      start: 'Dec 2022',
      end: 'May 2023',
      description: [
        'Integrated GoHighLevel (GHL) CRM with automated lead pipeline.',
        'Deployed ChatGPT-powered WhatsApp bot for instant replies and lead qualification.',
        'Built automated lead capture and deduplication across Facebook Ads, WhatsApp, and calls via Make.com + Twilio.',
        'Created dynamic quoting system using Google Forms, Airtable, and custom pricing logic.',
        'Proposed Airtable-based inventory tracker for stock, order picking, and deliveries.',
      ],
      skills: [
        'JavaScript',
        'Node.js',
        'GoHighLevel',
        'Make.com',
        'Google Maps',
        'SalesForce',
        'Codeweavers',
        'Whatsapp Business API',
        'Twilio',
        'Airtable',
        'OpenAI',
        'ChatGPT-3.5',
      ],
    },
    {
      company: 'Triad Diagnostic Solutions',
      url: '',
      icon: triaddiagnosticsolutions,
      iconMin: triaddiagnosticsolutionsMin,
      location: 'Noblesville, United States',
      contract: 'Full-time',
      position: 'Automation & CRM Developer',
      start: 'Sep 2020',
      end: 'Sep 2021',
      description: [
        'Designed and implemented multi-channel automated workflows to reduce no-shows.',
        'Developed dynamic email and SMS sequences with conditional logic for personalized communications.',
        'Integrated real-time notifications and team alerts for appointment status and follow-ups.',
        'Leveraged tagging, segmentation, and Google Ads custom audiences to re-engage leads.',
        'Optimized workflows and client communication processes for higher engagement and conversion.',
      ],
      skills: [
        'CRM Automation',
        'Workflow Automation',
        'Email & SMS Marketing',
        'Google Ads',
        'Lead Re-engagement',
        'Real-time Notifications',
        'Segmentation & Tagging',
      ],
    },
    {
      company: 'Raso Solutions',
      url: '',
      icon: raso,
      iconMin: rasoMin,
      location: 'Cebu City, Philippines',
      contract: 'Full-time',
      position: 'Web Developer',
      start: 'Oct 2016',
      end: 'Sep 2018',
      description: [
        'Building new car dealership websites using an in-house CMS. This involves translating mock-ups to dynamic and highly intuitive websites.',
        'Integrating 3rd party APIs such as Google Maps, SalesForce, Codeweavers.',
      ],
      skills: [
        'Adobe Photoshop',
        'JavaScript',
        'JQuery',
        'PHP',
        'Google Maps',
        'SalesForce',
        'Codeweavers',
      ],
    },
    {
      company: 'Mango Interactive BPO Inc / Clever Local Media',
      url: '',
      icon: cleverlocal,
      iconMin: cleverlocalMin,
      location: 'Cebu City, Philippines',
      contract: 'Full-time',
      position: 'Web Developer / Acting Team Leader',
      start: 'Aug 2015',
      end: 'Sep 2016',
      description: [
        'Implementing Responsive Web Design for Private Blog Networks (PBN).',
        'Building E-Commerce Websites.',
        'Managing the company\'s domains, web hostings and SSL certificates.',
        'Managing the Lead Generation and Email Marketing Teams.',
        'Data scraping of sales leads from E-Commerce websites.',
      ],
      skills: [
        'React',
        'Next Js',
        'Node JS',
        'DevOps',
        'Material UI',
        'MySQL',
        'Git',
        'PHP',
      ],
    },
  ],
  languages: [
    // {
    //   name: 'English',
    //   level: '',
    // },
  ],
  award: [
    {
      date: 'April 27, 2014',
      award: 'Proficiency in Computer Networking',
      support: 'College of Computer Studies and Systems',
      icon: '',
      iconMin: '',
    },
    {
      date: 'S.Y 2012-2013',
      award: 'Certificate of Academic Excellence / Dean\'s Lister',
      support: 'College of Computer Studies and Systems',
      icon: '',
      iconMin: '',
    },
    {
      date: 'S.Y 2012-2013',
      award: 'Best OJT',
      support: 'College of Computer Studies and Systems',
      icon: '',
      iconMin: '',
    },
    {
      date: 'S.Y 2012-2013',
      award: 'Service Award',
      support: 'College of Computer Studies and Systems',
      icon: '',
      iconMin: '',
    },
    {
      date: 'S.Y 2012-2013',
      award: 'Character Award',
      support: 'College of Computer Studies and Systems',
      icon: '',
      iconMin: '',
    },
  ],
  certificate: [
    // {
    //   date: 'May 14, 2018',
    //   issue: 'HTML Fundamentals course - Certificate',
    //   number: '#1014-561928',
    //   url: 'https://www.sololearn.com/Certificate/1014-561928/pdf',
    //   icon: '',
    //   iconMin: '',
    // },
    // {
    //   date: 'February 10, 2017',
    //   issue: 'SQL Fundamentals course - Certificate',
    //   number: '#1060-561928',
    //   url: 'https://www.sololearn.com/Certificate/1060-561928/pdf',
    //   icon: '',
    //   iconMin: '',
    // },
    // {
    //   date: 'February 9, 2017',
    //   issue: 'jQuery Tutorial course - Certificate',
    //   number: '#1082-561928',
    //   url: 'https://www.sololearn.com/Certificate/1082-561928/pdf',
    //   icon: '',
    //   iconMin: '',
    // },
    // {
    //   date: 'July 19, 2016',
    //   issue: 'CSS Fundamentals course - Certificate',
    //   number: '#1023-561928',
    //   url: 'https://www.sololearn.com/Certificate/1023-561928/pdf',
    //   icon: '',
    //   iconMin: '',
    // },
    // {
    //   date: 'July 13, 2016',
    //   issue: 'JavaScript Tutorial course - Certificate',
    //   number: '#1024-561928',
    //   url: 'https://www.sololearn.com/Certificate/1024-561928/pdf',
    //   icon: '',
    //   iconMin: '',
    // },
    // {
    //   date: 'June 26, 2016',
    //   issue: 'PHP Tutorial course - Certificate',
    //   number: '#1059-561928',
    //   url: 'https://www.sololearn.com/Certificate/1059-561928/pdf',
    //   icon: '',
    //   iconMin: '',
    // },
    {
      date: 'April 2011',
      issue: 'National Certificate II - Computer Hardware Servicing',
      number: '#11090402005163',
      url: '',
      icon: '',
      iconMin: '',
    },
    {
      date: 'February 24-25, 2010',
      issue: 'Research Forum and Presentations',
      number: '',
      url: '',
      icon: '',
      iconMin: '',
    },
    {
      date: 'S.Y 2010-2011',
      issue: 'PHP Web Development',
      number: '',
      url: '',
      icon: '',
      iconMin: '',
    },
    {
      date: 'S.Y 2008-2009',
      issue: 'Computer Virus Awareness, Detection and Removal',
      number: '',
      url: '',
      icon: '',
      iconMin: '',
    },
  ],
  contact: {
    address: 'Manila City, National Capital Region, Philippines',
    email: 'mimperial0083@gmail.com',
    phone: '+63 953 428 2243',
    // skype: 'https://join.skype.com/invite/bjG8qlnjyTLi',
    website: 'https://portfolio-marjay-imperial.vercel.app/',
    linkedin: 'https://www.linkedin.com/in/marjay-imperial-16289b390/',
    github: 'https://www.github.com/royxlab',
    // discord: 'https://discord.gg/AwzzqjHz',
    // researchgate: 'https://www.researchgate.net/profile',
    // gitlab: 'https://www.gitlab.com/royxlab',
    // deviantart: 'https://www.deviantart.com/royxlab',
  },
};

export default details;
